<template>
  <div class="search-result-item">
    <div class="result-meta">
      <span class="result-id">#{{ data.id }}</span>
      <span v-if="data._source.isolation_country" class="meta-tag location">
        <i class="icon-loc"></i> {{ data._source.isolation_country }}
      </span>
      <span v-if="data._source.host" class="meta-tag host">
        Host: {{ data._source.host }}
      </span>
    </div>

    <h3 class="result-title" @click="handleDetail">
      <span v-if="data.highlight?.name_txt" v-html="data.highlight.name_txt[0]"></span>
      <span v-else>{{ data._source.name_txt }}</span>
      <span v-if="data._source.name_txt_zh" class="zh-name-inline">
        {{ data._source.name_txt_zh }}
      </span>
    </h3>

    <div class="result-snippet">
      <div class="info-row">
        <span class="info-label">Genome ID:</span>
        <span class="info-val code">{{ data._source.genome_id }}</span>
      </div>

      <div class="taxonomy-line">
        <template v-for="(val, key) in quickTaxonomy" :key="key">
          <span v-if="val" class="tax-mini-item">
            {{ val }}
          </span>
        </template>
      </div>
    </div>

    <div v-if="data._source.disease" class="result-footer">
      关联疾病: <span class="disease-tag">{{ data._source.disease }}</span>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  import { useRouter } from 'vue-router';
  const props = defineProps({
    // 注意：这里接收的是包含 _source 和 highlight 的完整 item 对象
    data: { type: Object, required: true }
  });

  const router = useRouter();

  // 提取简要的分类路径用于副标题展示
  const quickTaxonomy = computed(() => {
    const s = props.data._source;
    return {
      phylum: s.phylum,
      clas: s.clas,
      genus: s.genus
    };
  });

  const handleDetail = () => {
    // 模拟点击跳转或展开逻辑
    router.push({
      path: '/pathogenic',
      query: { database_name: props.data._index, id: props.data._id }
    });
  };
</script>

<style scoped>
  .search-result-item {
    width: 100%;
    padding: 16px 0;
    background: transparent;
    border-bottom: 1px solid #f0f0f0;
    /* 列表分割线 */
    text-align: left;
  }

  .search-result-item:hover .result-title {
    text-decoration: underline;
  }

  /* 顶部元数据 */
  .result-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 12px;
    margin-bottom: 6px;
  }

  .result-id {
    color: #70757a;
  }

  .meta-tag {
    padding: 1px 6px;
    background: #e8f0fe;
    color: #1967d2;
    border-radius: 4px;
  }

  /* 标题样式 */
  .result-title {
    margin: 0 0 6px 0;
    font-size: 18px;
    color: #1a0dab;
    cursor: pointer;
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  /* 深度定制高亮样式 */
  :deep(em) {
    font-style: normal;
    color: #d93025;
    /* 红色高亮 */
    font-weight: bold;
  }

  .zh-name-inline {
    font-size: 15px;
    color: #4d5156;
    font-weight: normal;
  }

  /* 信息展示区 */
  .result-snippet {
    font-size: 14px;
    color: #4d5156;
  }

  .info-row {
    margin-bottom: 4px;
  }

  .info-label {
    color: #70757a;
    margin-right: 6px;
  }

  .code {
    font-family: monospace;
    background: #f1f3f4;
    padding: 0 4px;
  }

  .taxonomy-line {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    color: #70757a;
    font-size: 13px;
  }

  .tax-mini-item:not(:last-child)::after {
    content: "•";
    margin: 0 8px;
    color: #dadce0;
  }

  /* 底部状态 */
  .result-footer {
    margin-top: 8px;
    font-size: 13px;
  }

  .disease-tag {
    color: #d93025;
    font-weight: 500;
  }
</style>